<template>
  <div class="container">
    <van-nav-bar
      id='van-nav-bar'
      title="推荐奖励"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="data-wrapper">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <!-- <van-cell v-for="item in list" :key="item" :title="item" /> -->
          <EarnItem v-for="item in orderList" :key="item.index" 
          :item="item"
          />
      </van-list>
      
    </div>
    <!-- <van-calendar v-model="show" @confirm="onConfirm" :min-date="minDate"/> -->
  </div>
</template>
<script>
import EarnItem from "@/components/EarnItem.vue";
import { getFriendEarn } from "../../utils/api";
import { app } from "../../utils/app";
import { NavBar, List } from "vant";
import Vue from "vue";
import Vuex from "vuex";

Vue.use(NavBar);
Vue.use(Vuex);
Vue.use(List);

// @ is an alias to /src

export default {
  name: "ShopData",
  components: {EarnItem},
  data() {
    return {
      orderList: [],
      shopToken: "",
      show: "",
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(),
      currentDate: new Date(),
      searchDay: "",
      loading:false,
      finished:false,
      limit:20,
      offset:0,
      custId:''
    };
  },
  created() {
    this.custId = this.$route.query.id
    let shopToken = app.storage.get("shopToken");
    this.shopToken = shopToken;
    // console.log("shopToken:", this.shopToken);
    this.searchDay = this.timeToDay(new Date());
  },
  mounted() {},
  watch: {},
  methods: {
    async getFriendEarnFn(){
      let params = {
        limit: this.limit,
        offset: this.offset,
        custId: this.custId,
        usertoken: this.shopToken,
      }
      let res = await getFriendEarn(params);
      if (res.data.code == 0) {
        // console.log('res123:',res)
        // console.log('res1234:',res.data.tOrderList.length)
        if (res.data.tOrderList&&res.data.tOrderList.length != 0) {
          let newList = this.orderList.concat(res.data.tOrderList)
          // console.log('newList',newList)
          this.orderList = newList
          this.loading = false
          this.offset = this.offset + this.limit
        }else{
          this.finished = true
        }
      }
    },
    onClickLeft() {
      this.$router.back();
    },
    //日期选择确认
    onConfirm(value) {
      console.log(value);
      this.orderList=[],
      this.loading=false,
      this.finished=false,
      this.limit=20,
      this.offset=0
      this.searchDay = this.timeToDay(value);
      this.getOrderList();
      this.show = false;
    },
    onCancel() {
      this.show = false;
    },
    onChange(picker) {
      let value = picker.getValues();
      this.searchDay = `${value[0]}-${value[1]}-${value[2]}`;
    },
    timeToDay(value) {
      let year = value.getFullYear();
      let month =
        value.getMonth() > 8
          ? value.getMonth() + 1
          : `0${value.getMonth() + 1}`;
      let date = value.getDate()> 9? value.getDate(): `0${value.getDate()}`;
      let result = `${year}-${month}-${date}`;
      return result;
    },
    onLoad(){
      this.getFriendEarnFn();
      this.loading = true
    }
  },
};
</script>
<style>
.date-box {
  padding: 0 1rem;
  align-items: center;
}
.date-box .title {
  min-width: 4rem;
}
.date-box .days {
  min-width: 4rem;
}
.date-box .button-box {
  min-width: 4rem;
}
.data-wrapper button {
  width: 12.5rem;
  height: 3.125rem;
  margin: 0.625rem;
}
.pick-box {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 2;
}
</style>
